import { inject } from '@angular/core';
import { CanActivateFn, Router, ActivatedRouteSnapshot } from '@angular/router';
import { AuthService } from '../services/auth.service';
import { PropertyService } from '../../features/property/services/property.service';
import { map, switchMap, catchError } from 'rxjs/operators';
import { of } from 'rxjs';

export const propertyOwnerGuard: CanActivateFn = (route: ActivatedRouteSnapshot) => {
  const auth = inject(AuthService);
  const propertyService = inject(PropertyService);
  const router = inject(Router);

  const propertyId = route.paramMap.get('id');
  if (!propertyId) {
    return router.createUrlTree(['/not-found']);
  }

  return auth.user$.pipe(
    switchMap(user => {
      if (!user) {
        return of(router.createUrlTree(['/login'], { queryParams: { returnUrl: route.url.join('/') } }));
      }

      // Admins bypass ownership
      if (user.role === 'admin') {
        return of(true);
      }

      // Use your EXISTING endpoint: getUserProperties(userId)
      return propertyService.getUserProperties(user.id).pipe(
        map(properties => {
          const ownsProperty = properties.some(p => p.propertyId === propertyId);
          return ownsProperty
            ? true
            : router.createUrlTree(['/unauthorized']);
        }),
        catchError(() => of(router.createUrlTree(['/not-found'])))
      );
    })
  );
};